const branches = {
  headquarters: [
    {
      name: 'Tokyo Byokane Co., Ltd.',
      location: 'Japan (HQ)',
      address: '5-14, 2-Chome Yokoami, Sumida-ku, Tokyo, Japan',
      tel: '+81-3-36261211',
      mapUrl: null,
    },
    {
      name: 'Tokyo Byokane (S) Pte. Ltd.',
      location: 'Singapore',
      address: 'No. 3, 5th Lok Yang Road, Jurong Town, 629754 Singapore',
      tel: '+65-62654422',
      mapUrl: null,
    },
  ],
  subsidiaries: [
    {
      name: 'Byokane (U.S.A.) Corporation Atlanta',
      location: 'USA',
      address: '4025 Steve Reynolds Boulevard, Suite 114, Norcross, GA 30093, U.S.A.',
      tel: '+1-770-923-3228',
      mapUrl: 'https://maps.google.com/?q=4025+Steve+Reynolds+Boulevard+Norcross+GA',
    },
    {
      name: 'Byokane Mexico S.A. de C.V.',
      location: 'Mexico',
      address: 'Av. Rio Segura 161A, Col. Parque Tecno Industrial Castro del Rio, C.P. 36810, Irapuato, Guanajuato, Mexico',
      tel: '+52-462-800-6369',
      mapUrl: 'https://maps.google.com/?q=Irapuato+Guanajuato+Mexico',
    },
    {
      name: 'Byokane (Malaysia) Sdn. Bhd.',
      location: 'Malaysia',
      address: 'Suite L17-08, Level 17, PJX-HM Shah Tower, Persiaran Barat, 46050 Petaling Jaya, Selangor, Malaysia',
      tel: '+603-7931-9292',
      mapUrl: null,
    },
    {
      name: 'Tokyo Byokane (Thailand) Co., Ltd.',
      location: 'Thailand',
      address: 'N9/67-68, Moo 5, Phaholyothin Road, Tambol Klong Nueng, Amphur Klongluang, Patumthani 12120, Thailand',
      tel: '+66-2-5160916',
      mapUrl: null,
    },
    {
      name: 'Tokyo Byokane (Thailand) Co., Ltd. — Sriracha Office',
      location: 'Thailand',
      address: 'Room 1212, Harbor Mall Level 12, 4/222 Moo 10, Sukhumvit Road, Tungsukha, Sriracha, Chonburi 20230, Thailand',
      tel: '+66-3-3030760',
      mapUrl: null,
    },
    {
      name: 'Tokyo Byokane (S) Pte. Ltd. — Jakarta Representative',
      location: 'Indonesia',
      address: 'Skyline Building 9th Floor, Jl. M.H. Thamrin No. 9, Jakarta 10340, Indonesia',
      tel: '+62-21-3901439',
      mapUrl: null,
    },
    {
      name: 'Tokyo Byokane Vietnam Co., Ltd. — Hanoi',
      location: 'Vietnam',
      address: 'Plot P-11, Thang Long Industrial Park, Dong Anh District, Hanoi, Vietnam',
      tel: '+84-28-710-99590',
      mapUrl: 'https://maps.google.com/?q=Thang+Long+Industrial+Park+Hanoi',
    },
    {
      name: 'Tokyo Byokane Vietnam Co., Ltd. — Ho Chi Minh',
      location: 'Vietnam',
      address: 'No. 2 Room, 8th Floor, Pearl Plaza Buildings, 561A Dien Bien Phu, Ward 25, Binh Thanh District, Ho Chi Minh City, Vietnam',
      tel: '+84-28-710-99590',
      mapUrl: 'https://maps.google.com/?q=Pearl+Plaza+Ho+Chi+Minh',
    },
    {
      name: 'Tokyo Byokane Co., (Hong Kong) Ltd.',
      location: 'Hong Kong',
      address: '1713, 1717-1722, 17th Floor, Pacific Trade Centre, 2 Kai Hing Road, Kowloon Bay, Hong Kong',
      tel: '+852-27959633',
      mapUrl: null,
    },
    {
      name: 'Tokyo Byokane (Shanghai) Co., Ltd.',
      location: 'China',
      address: '1st & 2nd Floor, No. 4 Building, No. 115, Futexi 1st Road, Pilot Free Trade Zone, Shanghai 200131, China',
      tel: '+86-21-50460058',
      mapUrl: 'https://maps.google.com/?q=Futexi+1st+Road+Shanghai+Free+Trade+Zone',
    },
    {
      name: 'Tokyo Byokane (Zhuhai) Co., Ltd.',
      location: 'China',
      address: 'No. 31, Zhuhai Free Trade Zone, Zhuhai 519030, China',
      tel: '+86-756-8686008',
      mapUrl: 'https://maps.google.com/?q=Zhuhai+Free+Trade+Zone',
    },
    {
      name: 'Taiwan Byokane Co., Ltd. — Taipei Branch',
      location: 'Taiwan',
      address: '10F., No. 31, Sec. 3, Zhongshan N. Rd., Zhongshan Dist., Taipei City 10461, Taiwan (R.O.C.)',
      tel: '+886-2-2595-7187',
      mapUrl: null,
    },
  ],
  factories: [
    {
      name: 'Tokyo Byokane Vietnam Co., Ltd. (Factory)',
      location: 'Vietnam',
      address: 'Plot P10-P11, Thang Long Industrial Park, Vong La, Dong Anh, Hanoi, Vietnam',
      tel: '+84-24-39590061',
      mapUrl: 'https://maps.google.com/?q=Thang+Long+Industrial+Park+Hanoi',
    },
    {
      name: 'Tokyo Steel Philippines Corporation',
      location: 'Philippines',
      address: '5th Street Corner 3rd Avenue, Mactan Export Processing Zone 1, Ibo, Lapu-Lapu City, Cebu, Philippines 6015',
      tel: '+63-32-3403753',
      mapUrl: null,
    },
    {
      name: 'Shibasaki TB (Thailand) Co., Ltd.',
      location: 'Thailand',
      address: 'Hemaraj Saraburi Industrial Land, No. 71/6 Moo 6, Tambol Nhongpamho, Amphur Nongkhae, Saraburi 18140, Thailand',
      tel: '+66-36-373735-6',
      mapUrl: null,
    },
    {
      name: 'Toho Seiko Engineering (Shenzhen) Inc. Ltd.',
      location: 'China',
      address: 'Wenguang Village Industrial Park, Xili Town, Nanshan District, Shenzhen 518055, China',
      tel: '+86-755-2662-1171',
      mapUrl: null,
    },
    {
      name: 'Toho Seiko Precision Springs (Shanghai) Co., Ltd.',
      location: 'China',
      address: 'West Area 1st Floor, 47 Building, No. 11 Debao Road, Pilot Free Trade Zone, Shanghai 200131, China',
      tel: '+86-21-50483966',
      mapUrl: 'https://maps.google.com/?q=Debao+Road+Shanghai+Free+Trade+Zone',
    },
    {
      name: 'Dongguan Crown Screw Co., Ltd.',
      location: 'China',
      address: 'Yong Tou Guan Li Qu, Chang An Town, Dong Guan City, Guang Dong Province 511768, China',
      tel: '+86-769-8531-0353',
      mapUrl: null,
    },
  ],
};

export default branches;
